import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const TrashIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 12, height = 12, ...props }, ref) => {
    return (
      <svg
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M1.33337 3.08333H10.6667M1.91671 3.08333L2.50004 10.0833C2.50004 10.3928 2.62296 10.6895 2.84175 10.9083C3.06054 11.1271 3.35729 11.25 3.66671 11.25H8.33337C8.64279 11.25 8.93954 11.1271 9.15833 10.9083C9.37712 10.6895 9.50004 10.3928 9.50004 10.0833L10.0834 3.08333M4.25004 3.08333V1.33333C4.25004 1.17862 4.3115 1.03025 4.4209 0.920854C4.53029 0.811458 4.67866 0.75 4.83337 0.75H7.16671C7.32142 0.75 7.46979 0.811458 7.57919 0.920854C7.68858 1.03025 7.75004 1.17862 7.75004 1.33333V3.08333M4.83337 6L7.16671 8.33333M7.16671 6L4.83337 8.33333"
          stroke="#FF7C75"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
